import React from 'react'
import { t } from 'ttag'

import { DetailsCard } from 'components/shared/DetailsCard/DetailsCard'

import styles from './DefaultDescription.module.scss'

export const DefaultDescription = () => (
  <React.Fragment>
    <DetailsCard.Text>
      <span>{t`Select up to five competencies that are`}</span>
      <strong className={styles.bold}>{t`most relevant`}</strong>
      <span>{t`to the job requirements.`}</span>
    </DetailsCard.Text>
    <DetailsCard.Text>
      {t`Competencies are specific skills, knowledge and abilities that are required to perform a particular job. They are related to, but not the same as, personality traits. While personality traits refer to more stable patterns of behaviour over time, competencies reflect what a person is capable of in more specific work-related situations.`}
    </DetailsCard.Text>
    <DetailsCard.Text>
      {t`By selecting competencies, the algorithm that calculates test scores will be adjusted accordingly to favour relevant personality factors while the content of the candidate's tests remains unchanged. If you select several competencies from the same category (e.g. “Lead and motivate”), the factor correlated with this category (in this example: “Extraversion”) will be given more importance in the calculation of the total score.`}
    </DetailsCard.Text>
    <DetailsCard.Text>
      {t`The selected competencies can also form the basis for a competency-based interview. Each competency comes with tailored interview questions designed to draw out real examples of how the candidate has demonstrated that competency in practice.`}
    </DetailsCard.Text>
  </React.Fragment>
)
